import { Route, Routes, useLocation } from "react-router-dom";
import { Login } from "./login";
import { ForgottenPassword } from "./forgotten-password";
import { ResetPassword } from "./reset-password";
import { useEffect } from "react";
import storage from "utils/storage";

export const AuthRoutes = () => {
    let location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("login")) {
      storage.clearAllCaches();
    }
  }, [location]);
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="forgotten-password" element={<ForgottenPassword />} />
      <Route path="theresetpasswordlink/:code" element={<ResetPassword />} />
    </Routes>
  );
};
